module.exports = __webpack_public_path__ + "static/media/P1050543-min.e2125912.JPG";